export default __webpack_public_path__ + "static/media/icon-smile.2f1ed313.svg";